<template>
  <div class="d-flex flex-column fill-height">
    <div class="d-flex">
      <slot name="nav-bar"></slot>
    </div>
    <div class="d-flex max-width-full">
      <div class="flex-grow-1 max-width-full">
        <slot name="header-bar"></slot>
      </div>
    </div>
    <slot name="content"></slot>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Page',
};
</script>

<style lang="scss" scoped>
.max-width-full {
  max-width: 100%;
}
</style>
